import Radio from "@ch/components/Inputs/Radio";

interface PriceCardProps {
  isCurrentPlan: boolean;
  planName: string;
  price: string | number;
  planDetails: string;
  onChange: () => void;
  checked?: boolean;
}

const PriceCards = ({
  isCurrentPlan,
  planName,
  price,
  planDetails,
  onChange,
  checked,
}: PriceCardProps) => {
  return (
    <div
      aria-checked={checked}
      className={`flex flex-col gap-4 rounded-xl border bg-white p-6 ${
        checked || isCurrentPlan
          ? "border-green bg-white shadow-md"
          : "border bg-white-200 shadow-sm"
      }`}
      onClick={() => onChange()}
      onKeyUp={(e) => {
        if (e.key === "Enter") {
          onChange();
        } else e.preventDefault();
      }}
      role="checkbox"
      tabIndex={0}
    >
      {isCurrentPlan ? (
        <p className="flex h-7 w-fit items-center rounded-[100px] bg-primary p-[15px] text-sm text-white">
          Current Plan
        </p>
      ) : (
        <div className="h-7" />
      )}
      <div className="flex justify-between gap-4">
        <p className="text-lg">
          <span className="mr-4 font-semibold">{planName}</span>
          <span className="text-gray">{price}</span>
        </p>
        <Radio
          checked={checked}
          id={planName}
          name="plan"
          onChange={onChange}
        />
      </div>
      <p className="text-sm text-gray">{planDetails}</p>
    </div>
  );
};

export default PriceCards;
